import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black text-white p-8 font-mono">
          <h1 className="text-2xl text-red-500 font-bold mb-4">
            ¡Ups! Algo salió mal.
          </h1>
          <div className="bg-neutral-900 p-4 rounded border border-red-900 overflow-auto">
            <h2 className="text-xl mb-2">
              {this.state.error && this.state.error.toString()}
            </h2>
            <details className="whitespace-pre-wrap text-sm text-gray-400">
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </details>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="mt-6 px-6 py-2 bg-red-600 rounded hover:bg-red-700"
          >
            Recargar Página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
